import React, { useEffect, useState } from "react";
import { Plus, X } from "lucide-react";
import { BASE_URL } from "../../../config/api";
import InputField from "../../../Component/RetailerComponents/InputField";
import SelectField from "../../../Component/RetailerComponents/SelectField";
import axios from "axios";

export default function ProductModal({ isOpen, onClose, onSubmit, initialData }) {
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [validityMonths, setValidityMonths] = useState(12);
  const [claims, setClaims] = useState("");
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");
  const [marginType, setMarginType] = useState("percent");
  const [marginValue, setMarginValue] = useState("");
  const [adminmargin, setAdminMargin] = useState("");

  const [hsn, setHsn] = useState("998413");
  const [productType, setProductType] = useState("service");
  const [planType, setPlanType] = useState("Extended Warranty");

  const [labelType, setLabelType] = useState("regular");
  const [subvaliditydays, setsubValiditydays] = useState("");
  const [deviceLimit, setDeviceLimit] = useState("");

  const [status, setStatus] = useState(1);
  const [categories, setCategories] = useState([]);
  const [selectedCats, setSelectedCats] = useState([]);

  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const [features, setFeatures] = useState("");
  const [coverage, setCoverage] = useState("");
  const [exclusions, setexclusions] = useState("");
  const [benefits, setbenefits] = useState("");

  const [featureInput, setFeatureInput] = useState("");
  const [coverageInput, setCoverageInput] = useState("");
  const [exclusionInput, setExclusionInput] = useState("");
  const [benefitsinput, setBenefitsInput] = useState("");
  const [planFeatureMessage, setPlanFeatureMessage] = useState("");

  const [showDaysDropdown, setShowDaysDropdown] = useState(false);

  const [errors, setErrors] = useState({});

  const addItem = (value, setter, inputSetter) => {
    if (!value.trim()) return;
    setter((prev) => (prev ? `${prev}.${value.trim()}` : value.trim()));
    inputSetter("");
    setPlanFeatureMessage("");
  };

  const removeItem = (index, value, setter) => {
    const items = value.split(".");
    items.splice(index, 1);
    setter(items.join("."));
  };

  const DAYS_OPTIONS = [
    { label: "30 Days", value: 30 },
    { label: "45 Days", value: 45 },
    { label: "60 Days", value: 60 },
    { label: "90 Days", value: 90 },
    { label: "120 Days", value: 120 },
    { label: "180 Days", value: 180 },
    { label: "240 Days", value: 240 },
  ];

  const MONTH_OPTIONS = [
    { label: "3 Months", value: 3 },
    { label: "6 Months", value: 6 },
    { label: "12 Months", value: 12 },
    { label: "18 Months", value: 18 },
    { label: "24 Months", value: 24 },
  ];

  const monthToDays = (months) => Math.round((months * 365) / 12);
  const daysToMonth = (days) => Math.round(days / 30);

  const user = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const id = user?.id;

  const fetchCategories = async () => {

    try {

      const response =
        await axios.get(
          `${BASE_URL}warranty/get-categories`,
          {
            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const data =
        response.data;

      const activeCats =
        data.filter(
          (cat) =>
            Number(
              cat.status
            ) === 1
        );

      setCategories(
        activeCats
      );

    } catch (err) {

      console.log(
        err
      );

    }
  };

  

  useEffect(() => {
    if (!isOpen) return;
    fetchCategories();

    if (initialData) {
      setName(initialData.name || "");
      setImage(initialData.image || "");
      setValidityMonths(initialData.validity ? daysToMonth(initialData.validity) : 12);
      setClaims(initialData.claims || "");
      setFeatures(initialData.features || "");
      setMinValue(initialData.min_value || "");
      setMaxValue(initialData.max_value || "");
      setAdminMargin(initialData.margin || "");
      setCoverage(initialData.coverage || "");
      setexclusions(initialData.exclusions || "");
      setbenefits(initialData.retailer_benifits || "");
      setMarginType(initialData.is_percent == 1 ? "percent" : "mrp");
      setMarginValue(initialData.mrp || "");
      setLabelType(initialData.is_regular ? "regular" : "subscription");
      setsubValiditydays(initialData.sub_val_days || "");
      setDeviceLimit(initialData.enroll_max || "");
      setHsn(initialData.hsn_code || "998413");
      setProductType(initialData.product_type || "service");
      setPlanType(initialData.product_type || "Extended Warranty");
      setStatus(initialData.status || 1);
      const categoryIds = initialData.categories
        ? initialData.categories.map((c) => c.id)
        : [];
      setSelectedCats(categoryIds);
    } else {
      resetForm();
      fetchPlanFeatures(planType);
    }
  }, [initialData, isOpen]);

  const handlePlanChange = (value) => {
    setPlanType(value);
    fetchPlanFeatures(value);
  };

  const handleImageUpload = async (
    e
  ) => {

    const file =
      e.target.files[0];

    if (!file)
      return;

    setUploadLoading(
      true
    );

    const form =
      new FormData();

    form.append(
      "file",
      file
    );

    form.append(
      "tag",
      "Product"
    );

    try {

      const response =
        await axios.post(
          `${BASE_URL}warranty/upload-file`,
          form,
          {
            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "multipart/form-data",
            },
          }
        );

      const data =
        response.data;

      if (
        data?.data
          ?.file_url
      ) {

        setImage(
          data.data.file_url
        );
      }

    } catch (err) {

      console.error(
        err
      );

      alert(
        err?.response?.data
          ?.message ||
        "Image upload failed"
      );

    } finally {

      setUploadLoading(
        false
      );

    }
  };

  const fetchPlanFeatures = async (
  selectedPlanType
) => {

  try {

    const response =
      await axios.get(
        `${BASE_URL}warranty/get-features`,
        {
          params: {
            product_type:
              selectedPlanType,
          },

          headers: {
            Accept:
              "application/json",

            "Content-Type":
              "application/json",
          },
        }
      );

    const result =
      response.data;

    if (
      result?.status &&
      result?.data
        ?.length > 0
    ) {

      const apiData =
        result.data[0];

      setFeatures(
        apiData.features || ""
      );

      setCoverage(
        apiData.coverage || ""
      );

      setexclusions(
        apiData.exclusions ||
          ""
      );

      setPlanFeatureMessage(
        ""
      );

    } else {

      setFeatures(
        ""
      );

      setCoverage(
        ""
      );

      setexclusions(
        ""
      );

      setPlanFeatureMessage(
        "No features, coverage and exclusions found for selected type. Please add them to create."
      );
    }

  } catch (err) {

    console.log(
      "Failed to fetch plan features",
      err
    );

  }
};

  const toggleCategory = (catId) => {
    setSelectedCats((prev) =>
      prev.includes(catId) ? prev.filter((c) => c !== catId) : [...prev, catId]
    );
  };

  const resetForm = () => {
    setName("");
    setImage("");
    setValidityMonths(12);
    setClaims("");
    setMinValue("");
    setMaxValue("");
    setMarginType("percent");
    setMarginValue("");
    setAdminMargin("");
    setHsn("998413");
    setProductType("service");
    setLabelType("regular");
    setStatus(1);
    setSelectedCats([]);
    setFeatures("");
    setCoverage("");
    setexclusions("");
    setFeatureInput("");
    setCoverageInput("");
    setExclusionInput("");
    setsubValiditydays("");
    setDeviceLimit("");
  };

  const validateForm = () => {
  let newErrors = {};

  if (!name.trim()) newErrors.name = "Product name is required";
  if (!planType) newErrors.planType = "Plan type is required";
  if (!validityMonths) newErrors.validityMonths = "Expiry period is required";
  if (!marginType) newErrors.marginType = "Margin type is required";

  if (!minValue) newErrors.minValue = "Min value is required";
  if (!maxValue) newErrors.maxValue = "Max value is required";
  if (!marginValue) newErrors.marginValue = "MRP is required";
  if (!adminmargin) newErrors.adminmargin = "Company margin is required";
  if (!claims) newErrors.claims = "Number of claims is required";

  if (!image) newErrors.image = "Product image is required";

  if (selectedCats.length === 0)
    newErrors.categories = "Please select at least one category";

  if (!features)
    newErrors.features = "Please add at least one feature";

  if (!coverage)
    newErrors.coverage = "Please add at least one coverage";

  if (!exclusions)
    newErrors.exclusions = "Please add at least one exclusion";

  if (labelType === "subscription") {
    if (!subvaliditydays)
      newErrors.subvaliditydays =
        "Subscription validation days is required";

    if (!deviceLimit)
      newErrors.deviceLimit =
        "Device enrollment limit is required";

    if (!benefits)
      newErrors.benefits =
        "Please add at least one retailer benefit";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

  const handleSave = async (
  e
) => {

  e.preventDefault();

  // VALIDATE FIRST
  if (
    !validateForm()
  ) {

    return;
  }

  setLoading(
    true
  );

  const selectedCategoryNames =
    categories
      .filter((cat) =>
        selectedCats.includes(
          cat.id
        )
      )
      .map(
        (cat) =>
          cat.name
      )
      .join(", ");

  const payload = {

    name,

    plan_type:
      planType,

    image,

    validity:
      monthToDays(
        validityMonths
      ),

    claims:
      Number(
        claims
      ),

    features,

    min_value:
      Number(
        minValue
      ),

    max_value:
      Number(
        maxValue
      ),

    margin:
      Number(
        adminmargin
      ),

    is_fixed:
      marginType ===
      "mrp"
        ? 1
        : 0,

    is_percent:
      marginType ===
      "percent"
        ? 1
        : 0,

    is_regular:
      labelType ===
      "regular"
        ? 1
        : 0,

    is_offer:
      labelType ===
      "subscription"
        ? 1
        : 0,

    sub_val_days:
      subvaliditydays,

    enroll_max:
      deviceLimit,

    is_taxable:
      true,

    product_type:
      productType,

    hsn_or_sac:
      hsn,

    mrp:
      Number(
        marginValue
      ),

    status:
      Number(
        status
      ),

    category_ids:
      selectedCats,

    category_name:
      selectedCategoryNames,

    company_id:
      id,

    coverage,

    exclusions,

    retailer_benifits:
      benefits,
  };

  try {

    const url =
      initialData?.id
        ? `${BASE_URL}warranty/update-product/${initialData.id}`
        : `${BASE_URL}warranty/create-product`;

    await axios.post(
      url,
      payload,
      {
        headers: {
          Accept:
            "application/json",

          "Content-Type":
            "application/json",
        },
      }
    );

    resetForm();

    onSubmit();

  } catch (err) {

    console.error(
      err
    );

    alert(
      err?.response?.data
        ?.message ||
      err?.message ||
      "Failed to save product"
    );

  } finally {

    setLoading(
      false
    );

  }
};

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white w-[1100px] max-h-[90vh] overflow-y-auto rounded-xl p-6 relative">

        <button
          className="absolute top-3 right-3"
          onClick={() => { resetForm(); onClose(); }}
        >
          <X size={20} />
        </button>

        <h2 className="text-lg font-semibold mb-5">
          {initialData ? "Update Product" : "Add Product"}
        </h2>

        <form onSubmit={handleSave} className="space-y-5">

          {/* ── ROW 1 ── */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

            <div>
               <InputField label="Product Name" required type="text" className="w-full border px-3 py-2 rounded"
                value={name} onChange={(value) => setName(value)}  />
                {errors.name && (
                  <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                )}
            </div>

            <div>
              <SelectField
              label="Product Type"
              value={planType}
              required
              onChange={handlePlanChange}
              options={[
                { label: "Extended Warranty", value: "Extended Warranty" },
                { label: "Total Protection", value: "Total Protection" },
                { label: "Screen Damage", value: "Screen Damage" },
              ]}
            />

            
            </div>

            <div>
              <SelectField
              label="Expiry Period"
              required
              value={validityMonths}
              onChange={(value) => setValidityMonths(Number(value))}
              options={MONTH_OPTIONS}
            /> 
          
            </div>
            <SelectField
              label="Margin Type"
              value={marginType}
              onChange={(value) => setMarginType(value)}
              required
              options={[
                { label: "Percent", value: "percent" },
                { label: "MRP", value: "mrp" },
              ]}
            />
           
          </div>

          {/* ── ROW 2 ── */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

             <SelectField
              label="Status"
              value={status}
              required
              onChange={(value) => setStatus(value)}
              options={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
            />

            <div>
              <InputField
                label="Min Value"
                required
                type="number"
                value={minValue}
                onChange={(value) => setMinValue(value)}
              />
              {errors.minValue && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.minValue}
                </p>
              )}
            </div>

            <div>
              <InputField
                label="Max Value"
                required
                type="number"
                value={maxValue}
                onChange={(value) => setMaxValue(value)}
              />
              {errors.maxValue && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.maxValue}
                </p>
              )}
            </div>

            <div>
              <InputField
                label={marginType === "percent" ? "MRP (%)" : "MRP (₹)"}
                required
                type="number"
                value={marginValue}
                onChange={(value) => setMarginValue(value)}
              />

              {errors.marginValue && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.marginValue}
                </p>
              )}
            </div>
            
          </div>

          {/* ── ROW 3 ── */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

            <div>
              <InputField
                label={marginType === "percent" ? "Company Margin (%)" : "Company Margin (₹)"}
                required
                type="number"
                value={adminmargin}
                onChange={(value) => setAdminMargin(value)}
              />

              {errors.adminmargin && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.adminmargin}
                </p>
              )}
            </div>

            <div>
              <InputField
                label="Number of Claims"
                required
                type="number"
                value={claims}
                onChange={(value) => setClaims(value)}
              />

              {errors.claims && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.claims}
                </p>
              )}
            </div>

            <InputField
              label="HSN / SAC"
              required
              value={hsn}
              disabled
              className="w-full border px-3 py-2 rounded bg-gray-100"
            />

            {errors.hsn && (
              <p className="text-red-500 text-xs mt-1">
                {errors.hsn}
              </p>
            )}
            <InputField
              label="Product Type"
              required
              value="Service"
              disabled
              className="w-full border px-3 py-2 rounded bg-gray-100"
            />
            
            
          </div>

          {/* ── ROW 4: Plan Type + Product Category ── */}
          <div className="grid grid-cols-3 md:grid-cols-4 gap-4 items-start">
            <div>
              <InputField
                label="Upload Image"
                required
                type="file"
                onChange={handleImageUpload}
              />
              {image && (
                <img src={image} className="w-16 h-16 mt-1 border rounded object-cover" />
              )}
              {uploadLoading && (
                <p className="text-xs text-gray-500 mt-1">Uploading...</p>
              )}

              {errors.image && (
              <p className="text-red-500 text-xs mt-1">
                {errors.image}
              </p>
            )}
            </div>

            <div>
              <p className="text-sm font-medium mb-2">Plan Type</p>
              <div className="flex gap-2">
                {[
                  { label: "Regular", value: "regular" },
                  { label: "Subscription", value: "subscription" },
                ].map((item) => (
                  <span
                    key={item.value}
                    onClick={() => setLabelType(item.value)}
                    className={`px-3 py-1.5 text-xs rounded-full cursor-pointer border select-none transition
                      ${labelType === item.value
                        ? "bg-blue-600 text-white border-blue-600"
                        : "bg-slate-100 text-slate-600 border-slate-300 hover:bg-slate-200"
                      }`}
                  >
                    {item.label}
                  </span>
                ))}
              </div>

              {errors.labelType && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.labelType}
                </p>
              )}
            </div>

            <div className="col-span-2">
              <p className="text-sm font-medium mb-2">Product Category</p>
              <div className="flex flex-wrap gap-2">
                {categories.map((c) => {
                  const isSelected = selectedCats.includes(c.id);
                  return (
                    <span
                      key={c.id}
                      onClick={() => toggleCategory(c.id)}
                      className={`px-3 py-1.5 text-xs rounded-full cursor-pointer border select-none transition
                        ${isSelected
                          ? "bg-blue-600 text-white border-blue-600"
                          : "bg-slate-100 text-slate-600 border-slate-300 hover:bg-slate-200"
                        }`}
                    >
                      {c.name}
                    </span>
                  );
                })}
              </div>

              {errors.categories && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.categories}
                </p>
              )}
            </div>
          </div>

          {/* ── SUBSCRIPTION SETTINGS (visible only when Subscription is selected) ── */}
          {labelType === "subscription" && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm font-semibold text-blue-700 mb-3">Subscription Settings</p>
              <div className="grid grid-cols-4 gap-4">
                {/* <SelectField
                  label="Subscription Validation (Days)"
                  required
                  value={subvaliditydays}
                  onChange={(value) => setsubValiditydays(Number(value))}
                  options={DAYS_OPTIONS}
                /> */}

              <div className="relative">
                <label className="text-sm font-medium block mb-1">
                  Subscription Validation (Days)
                  <span className="text-red-500"> *</span>
                </label>

                <input
                  type="number"
                  min="1"
                  placeholder="Select or enter days"
                  value={subvaliditydays}
                  onChange={(e) => {

                    const value = e.target.value;

                    // ❌ BLOCK NEGATIVE
                    if (Number(value) < 0) return;

                    setsubValiditydays(value);
                  }}
                  onKeyDown={(e) => {

                    // ❌ BLOCK -, +, e
                    if (
                      e.key === "-" ||
                      e.key === "+" ||
                      e.key === "e"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onFocus={() =>
                    setShowDaysDropdown(true)
                  }
                  className="
                    w-full border px-3 py-2 rounded-lg
                    text-sm bg-white
                    focus:ring-2 focus:ring-blue-500
                    outline-none
                  "
                />

                {/* Custom Dropdown */}
                {showDaysDropdown && (
                  <div
                    className="
                      absolute z-50 mt-1 w-full
                      bg-white border rounded-xl shadow-lg
                      max-h-52 overflow-y-auto
                    "
                  >
                    {DAYS_OPTIONS.map((d) => (
                      <button
                        type="button"
                        key={d.value}
                        onClick={() => {
                          setsubValiditydays(d.value);
                          setShowDaysDropdown(false);
                        }}
                        className="
                          w-full text-left px-4 py-2
                          hover:bg-blue-50
                          text-sm
                        "
                      >
                        {d.label}
                      </button>
                    ))}
                  </div>
                )}

                {errors.subvaliditydays && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.subvaliditydays}
                  </p>
                )}
              </div>
                <InputField
                  label="Device Enrollment Upto"
                  type="number"
                  required
                  value={deviceLimit}
                  onChange={(value) => setDeviceLimit(Number(value))}
                  placeholder="Enter number of devices"
                />
              </div>
            </div>
          )}

          {/* ── FEATURES / COVERAGE / EXCLUSIONS ── */}
          <div className={`grid gap-4 ${labelType === "subscription" ? "grid-cols-1 md:grid-cols-4" : "grid-cols-1 md:grid-cols-3"}`}>

            {/* FEATURES */}
            <div>
              <label className="text-sm font-medium">Product Features</label>
              <div className="relative mt-1">
                <input
                  value={featureInput}
                  onChange={(e) => setFeatureInput(e.target.value)}
                  placeholder="Type feature and press +"
                  className="w-full border px-3 py-2 pr-10 rounded"
                />
                <button
                  type="button"
                  onClick={() => addItem(featureInput, setFeatures, setFeatureInput)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
                  disabled={!featureInput.trim()}
                >
                  <Plus size={16} />
                </button>
              </div>
              {planFeatureMessage && (
                <div className="mt-3 p-3 rounded-md bg-amber-50 border border-amber-200 text-amber-700 text-sm">
                  {planFeatureMessage}
                </div>
              )}
              <div className="flex flex-wrap gap-2 mt-3">
                {features &&
                  features.split(".").map((f, i) => (
                    <Chip key={i} label={f} onRemove={() => removeItem(i, features, setFeatures)} />
                  ))}
              </div>
            </div>

            {/* COVERAGE */}
            <div>
              <label className="text-sm font-medium">Coverage</label>
              <div className="relative mt-1">
                <input
                  value={coverageInput}
                  onChange={(e) => setCoverageInput(e.target.value)}
                  placeholder="Type coverage and press +"
                  className="w-full border px-3 py-2 pr-10 rounded"
                />
                <button
                  type="button"
                  onClick={() => addItem(coverageInput, setCoverage, setCoverageInput)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
                  disabled={!coverageInput.trim()}
                >
                  <Plus size={16} />
                </button>
              </div>
              <div className="flex flex-wrap gap-2 mt-3">
                {coverage &&
                  coverage.split(".").map((c, i) => (
                    <Chip key={i} label={c} onRemove={() => removeItem(i, coverage, setCoverage)} />
                  ))}
              </div>
            </div>

            {/* EXCLUSIONS */}
            <div>
              <label className="text-sm font-medium">Exclusions</label>
              <div className="relative mt-1">
                <input
                  value={exclusionInput}
                  onChange={(e) => setExclusionInput(e.target.value)}
                  placeholder="Type exclusion and press +"
                  className="w-full border px-3 py-2 pr-10 rounded"
                />
                <button
                  type="button"
                  onClick={() => addItem(exclusionInput, setexclusions, setExclusionInput)}
                  disabled={!exclusionInput.trim()}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
                >
                  <Plus size={16} />
                </button>
              </div>
              <div className="flex flex-wrap gap-2 mt-3">
                {exclusions &&
                  exclusions.split(".").map((e, i) => (
                    <Chip key={i} label={e} onRemove={() => removeItem(i, exclusions, setexclusions)} />
                  ))}
              </div>
            </div>

            {labelType === "subscription" && (
              <div>
                <label className="text-sm font-medium">Retailer Benefits</label>
                <div className="relative mt-1">
                  <input
                    value={benefitsinput}
                    onChange={(e) => setBenefitsInput(e.target.value)}
                    placeholder="Type benefit and press +"
                    className="w-full border px-3 py-2 pr-10 rounded"
                  />
                  <button
                    type="button"
                    onClick={() => addItem(benefitsinput, setbenefits, setBenefitsInput)}
                    disabled={!benefitsinput.trim()}
                    className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
                  >
                    <Plus size={16} />
                  </button>
                </div>

                <div className="flex flex-wrap gap-2 mt-3">
                  {benefits &&
                    benefits.split(".").map((b, i) => (
                      <Chip key={i} label={b} onRemove={() => removeItem(i, benefits, setbenefits)} />
                    ))}
                </div>
              </div>
            )}

          </div>

          {/* ── SUBMIT ── */}
          <div className="flex justify-end pt-2">
            <button
              type="submit"
              className="w-[200px] bg-blue-600 text-white py-2 rounded"
              disabled={loading}
            >
              {loading ? "Saving..." : initialData ? "Update Product" : "Add Product"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

const Chip = ({ label, onRemove }) => (
  <div className="flex items-center gap-2 bg-slate-100 border rounded-full px-3 py-1 text-sm">
    <span>{label}</span>
    <button type="button" onClick={onRemove} className="text-slate-500 hover:text-red-500">
      ✕
    </button>
  </div>
);

// import React, { useEffect, useState } from "react";
// import { Plus, X } from "lucide-react";
// import { BASE_URL } from "../../../config/api";
// import InputField from "../../../Component/RetailerComponents/InputField";
// import SelectField from "../../../Component/RetailerComponents/SelectField";

// export default function ProductModal({ isOpen, onClose, onSubmit, initialData }) {
//   const [name, setName] = useState("");
//   const [image, setImage] = useState("");
//   const [validityMonths, setValidityMonths] = useState(12);
//   const [claims, setClaims] = useState("");
//   const [minValue, setMinValue] = useState("");
//   const [maxValue, setMaxValue] = useState("");
//   const [marginType, setMarginType] = useState("percent");
//   const [marginValue, setMarginValue] = useState("");
//   const [adminmargin, setAdminMargin] = useState("");

//   const [hsn, setHsn] = useState("998413");
//   const [productType, setProductType] = useState("service");
//   const [planType, setPlanType] = useState("Extended Warranty");

//   const [labelType, setLabelType] = useState("regular");
//   const [subvaliditydays, setsubValiditydays] = useState("");
//   const [deviceLimit, setDeviceLimit] = useState("");

//   const [status, setStatus] = useState(1);
//   const [categories, setCategories] = useState([]);
//   const [selectedCats, setSelectedCats] = useState([]);

//   const [loading, setLoading] = useState(false);
//   const [uploadLoading, setUploadLoading] = useState(false);

//   const [features, setFeatures] = useState("");
//   const [coverage, setCoverage] = useState("");
//   const [exclusions, setexclusions] = useState("");
//   const [benefits, setbenefits] = useState("");

//   const [featureInput, setFeatureInput] = useState("");
//   const [coverageInput, setCoverageInput] = useState("");
//   const [exclusionInput, setExclusionInput] = useState("");
//   const [benefitsinput, setBenefitsInput] = useState("");
//   const [planFeatureMessage, setPlanFeatureMessage] = useState("");

//   const addItem = (value, setter, inputSetter) => {
//     if (!value.trim()) return;
//     setter((prev) => (prev ? `${prev}.${value.trim()}` : value.trim()));
//     inputSetter("");
//     setPlanFeatureMessage("");
//   };

//   const removeItem = (index, value, setter) => {
//     const items = value.split(".");
//     items.splice(index, 1);
//     setter(items.join("."));
//   };

//   const DAYS_OPTIONS = [
//     { label: "30 Days", value: 30 },
//     { label: "60 Days", value: 60 },
//     { label: "120 Days", value: 120 },
//     { label: "180 Days", value: 180 },
//     { label: "240 Days", value: 240 },
//   ];

//   const MONTH_OPTIONS = [
//     { label: "3 Months", value: 3 },
//     { label: "6 Months", value: 6 },
//     { label: "12 Months", value: 12 },
//     { label: "18 Months", value: 18 },
//     { label: "24 Months", value: 24 },
//   ];

//   const monthToDays = (months) => Math.round((months * 365) / 12);
//   const daysToMonth = (days) => Math.round(days / 30);

//   const user = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const id = user?.id;

//   const fetchCategories = async () => {
//     try {
//       const res = await fetch(`${BASE_URL}warranty/get-categories`);
//       const data = await res.json();
//       const activeCats = data.filter((cat) => Number(cat.status) === 1);
//       setCategories(activeCats);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     if (!isOpen) return;
//     fetchCategories();

//     if (initialData) {
//       setName(initialData.name || "");
//       setImage(initialData.image || "");
//       setValidityMonths(initialData.validity ? daysToMonth(initialData.validity) : 12);
//       setClaims(initialData.claims || "");
//       setFeatures(initialData.features || "");
//       setMinValue(initialData.min_value || "");
//       setMaxValue(initialData.max_value || "");
//       setAdminMargin(initialData.margin || "");
//       setCoverage(initialData.coverage || "");
//       setexclusions(initialData.exclusions || "");
//       setbenefits(initialData.retailer_benifits || "");
//       setMarginType(initialData.is_percent == 1 ? "percent" : "mrp");
//       setMarginValue(initialData.mrp || "");
//       setLabelType(initialData.is_regular ? "regular" : "subscription");
//       setsubValiditydays(initialData.sub_val_days || "");
//       setDeviceLimit(initialData.enroll_max || "");
//       setHsn(initialData.hsn_code || "998413");
//       setProductType(initialData.product_type || "service");
//       setPlanType(initialData.plan_type || "Extended Warranty");
//       setStatus(initialData.status || 1);
//       const categoryIds = initialData.categories
//         ? initialData.categories.map((c) => c.id)
//         : [];
//       setSelectedCats(categoryIds);
//     } else {
//       resetForm();
//       fetchPlanFeatures(planType);
//     }
//   }, [initialData, isOpen]);

//   const handlePlanChange = (value) => {
//     setPlanType(value);
//     fetchPlanFeatures(value);
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setUploadLoading(true);
//     const form = new FormData();
//     form.append("file", file);
//     form.append("tag", "Product");
//     try {
//       const res = await fetch(`${BASE_URL}warranty/upload-file`, {
//         method: "POST",
//         body: form,
//       });
//       const data = await res.json();
//       if (data?.data?.file_url) setImage(data.data.file_url);
//     } catch (err) {
//       alert("Image upload failed");
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   const fetchPlanFeatures = async (selectedPlanType) => {
//     try {
//       const res = await fetch(
//         `${BASE_URL}warranty/get-features?product_type=${encodeURIComponent(selectedPlanType)}`
//       );
//       const result = await res.json();
//       if (result?.status && result?.data?.length > 0) {
//         const apiData = result.data[0];
//         setFeatures(apiData.features || "");
//         setCoverage(apiData.coverage || "");
//         setexclusions(apiData.exclusions || "");
//         setPlanFeatureMessage("");
//       } else {
//         setFeatures("");
//         setCoverage("");
//         setexclusions("");
//         setPlanFeatureMessage(
//           "No features, coverage and exclusions found for selected type. Please add them to create."
//         );
//       }
//     } catch (err) {
//       console.log("Failed to fetch plan features", err);
//     }
//   };

//   const toggleCategory = (catId) => {
//     setSelectedCats((prev) =>
//       prev.includes(catId) ? prev.filter((c) => c !== catId) : [...prev, catId]
//     );
//   };

//   const resetForm = () => {
//     setName("");
//     setImage("");
//     setValidityMonths(12);
//     setClaims("");
//     setMinValue("");
//     setMaxValue("");
//     setMarginType("percent");
//     setMarginValue("");
//     setAdminMargin("");
//     setHsn("998413");
//     setProductType("service");
//     setLabelType("regular");
//     setStatus(1);
//     setSelectedCats([]);
//     setFeatures("");
//     setCoverage("");
//     setexclusions("");
//     setFeatureInput("");
//     setCoverageInput("");
//     setExclusionInput("");
//     setsubValiditydays("");
//     setDeviceLimit("");
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const selectedCategoryNames = categories
//       .filter((cat) => selectedCats.includes(cat.id))
//       .map((cat) => cat.name)
//       .join(", ");

//     const payload = {
//       name,
//       plan_type: planType,
//       image,
//       validity: monthToDays(validityMonths),
//       claims: Number(claims),
//       features,
//       min_value: Number(minValue),
//       max_value: Number(maxValue),
//       margin: Number(adminmargin),
//       is_fixed: marginType === "mrp" ? 1 : 0,
//       is_percent: marginType === "percent" ? 1 : 0,
//       is_regular: labelType === "regular" ? 1 : 0,
//       is_offer: labelType === "subscription" ? 1 : 0,
//       sub_val_days: subvaliditydays,
//       enroll_max: deviceLimit,
//       is_taxable: true,
//       product_type: productType,
//       hsn_or_sac: hsn,
//       mrp: Number(marginValue),
//       status: Number(status),
//       category_ids: selectedCats,
//       category_name: selectedCategoryNames,
//       company_id: id,
//       coverage,
//       exclusions,
//       retailer_benifits: benefits,
//     };

//     try {
//       const url = initialData?.id
//         ? `${BASE_URL}warranty/update-product/${initialData.id}`
//         : `${BASE_URL}warranty/create-product`;

//       const res = await fetch(url, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) throw new Error("Failed to save product");
//       resetForm();
//       onSubmit();
//     } catch (err) {
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
//       <div className="bg-white w-[1100px] max-h-[90vh] overflow-y-auto rounded-xl p-6 relative">

//         <button
//           className="absolute top-3 right-3"
//           onClick={() => { resetForm(); onClose(); }}
//         >
//           <X size={20} />
//         </button>

//         <h2 className="text-lg font-semibold mb-5">
//           {initialData ? "Update Product" : "Add Product"}
//         </h2>

//         <form onSubmit={handleSave} className="space-y-5">

//           {/* ── ROW 1 ── */}
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

//             <div>
//                <InputField label="Product Name" required type="text" className="w-full border px-3 py-2 rounded"
//                 value={name} onChange={(value) => setName(value)}  />
//             </div>

//             <SelectField
//               label="Product Type"
//               value={planType}
//               required
//               onChange={handlePlanChange}
//               options={[
//                 { label: "Extended Warranty", value: "Extended Warranty" },
//                 { label: "Total Protection", value: "Total Protection" },
//                 { label: "Screen Damage", value: "Screen Damage" },
//               ]}
//             />
//             <SelectField
//               label="Expiry Period"
//               required
//               value={validityMonths}
//               onChange={(value) => setValidityMonths(Number(value))}
//               options={MONTH_OPTIONS}
//             />
//             <SelectField
//               label="Margin Type"
//               value={marginType}
//               onChange={(value) => setMarginType(value)}
//               required
//               options={[
//                 { label: "Percent", value: "percent" },
//                 { label: "MRP", value: "mrp" },
//               ]}
//             />
           
//           </div>

//           {/* ── ROW 2 ── */}
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

//              <SelectField
//               label="Status"
//               value={status}
//               required
//               onChange={(value) => setStatus(value)}
//               options={[
//                 { label: "Active", value: 1 },
//                 { label: "Inactive", value: 0 },
//               ]}
//             />

//             <InputField
//               label="Min Value"
//               required
//               type="number"
//               value={minValue}
//               onChange={(value) => setMinValue(value)}
//             />
//             <InputField
//               label="Max Value"
//               required
//               type="number"
//               value={maxValue}
//               onChange={(value) => setMaxValue(value)}
//             />
//             <InputField
//               label={marginType === "percent" ? "MRP (%)" : "MRP (₹)"}
//               required
//               type="number"
//               value={marginValue}
//               onChange={(value) => setMarginValue(value)}
//             />
            
//           </div>

//           {/* ── ROW 3 ── */}
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

//             <InputField
//               label={marginType === "percent" ? "Company Margin (%)" : "Company Margin (₹)"}
//               required
//               type="number"
//               value={adminmargin}
//               onChange={(value) => setAdminMargin(value)}
//             />

//             <InputField
//               label="Number of Claims"
//               required
//               type="number"
//               value={claims}
//               onChange={(value) => setClaims(value)}
//             />
//             <InputField
//               label="HSN / SAC"
//               required
//               value={hsn}
//               disabled
//               className="w-full border px-3 py-2 rounded bg-gray-100"
//             />
//             <InputField
//               label="Product Type"
//               required
//               value="Service"
//               disabled
//               className="w-full border px-3 py-2 rounded bg-gray-100"
//             />
            
//           </div>

//           {/* ── ROW 4: Plan Type + Product Category ── */}
//           <div className="grid grid-cols-3 md:grid-cols-4 gap-4 items-start">
//             <div>
//               <InputField
//                 label="Upload Image"
//                 required
//                 type="file"
//                 onChange={handleImageUpload}
//               />
//               {image && (
//                 <img src={image} className="w-16 h-16 mt-1 border rounded object-cover" />
//               )}
//               {uploadLoading && (
//                 <p className="text-xs text-gray-500 mt-1">Uploading...</p>
//               )}
//             </div>

//             <div>
//               <p className="text-sm font-medium mb-2">Plan Type</p>
//               <div className="flex gap-2">
//                 {[
//                   { label: "Regular", value: "regular" },
//                   { label: "Subscription", value: "subscription" },
//                 ].map((item) => (
//                   <span
//                     key={item.value}
//                     onClick={() => setLabelType(item.value)}
//                     className={`px-3 py-1.5 text-xs rounded-full cursor-pointer border select-none transition
//                       ${labelType === item.value
//                         ? "bg-blue-600 text-white border-blue-600"
//                         : "bg-slate-100 text-slate-600 border-slate-300 hover:bg-slate-200"
//                       }`}
//                   >
//                     {item.label}
//                   </span>
//                 ))}
//               </div>
//             </div>

//             <div className="col-span-2">
//               <p className="text-sm font-medium mb-2">Product Category</p>
//               <div className="flex flex-wrap gap-2">
//                 {categories.map((c) => {
//                   const isSelected = selectedCats.includes(c.id);
//                   return (
//                     <span
//                       key={c.id}
//                       onClick={() => toggleCategory(c.id)}
//                       className={`px-3 py-1.5 text-xs rounded-full cursor-pointer border select-none transition
//                         ${isSelected
//                           ? "bg-blue-600 text-white border-blue-600"
//                           : "bg-slate-100 text-slate-600 border-slate-300 hover:bg-slate-200"
//                         }`}
//                     >
//                       {c.name}
//                     </span>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* ── SUBSCRIPTION SETTINGS (visible only when Subscription is selected) ── */}
//           {labelType === "subscription" && (
//             <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
//               <p className="text-sm font-semibold text-blue-700 mb-3">Subscription Settings</p>
//               <div className="grid grid-cols-4 gap-4">
//                 <SelectField
//                   label="Subscription Validation (Days)"
//                   required
//                   value={subvaliditydays}
//                   onChange={(value) => setsubValiditydays(Number(value))}
//                   options={DAYS_OPTIONS}
//                 />
//                 <InputField
//                   label="Device Enrollment Upto"
//                   type="number"
//                   required
//                   value={deviceLimit}
//                   onChange={(value) => setDeviceLimit(Number(value))}
//                   placeholder="Enter number of devices"
//                 />
//               </div>
//             </div>
//           )}

//           {/* ── FEATURES / COVERAGE / EXCLUSIONS ── */}
//           <div className={`grid gap-4 ${labelType === "subscription" ? "grid-cols-1 md:grid-cols-4" : "grid-cols-1 md:grid-cols-3"}`}>

//             {/* FEATURES */}
//             <div>
//               <label className="text-sm font-medium">Product Features</label>
//               <div className="relative mt-1">
//                 <input
//                   value={featureInput}
//                   onChange={(e) => setFeatureInput(e.target.value)}
//                   placeholder="Type feature and press +"
//                   className="w-full border px-3 py-2 pr-10 rounded"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => addItem(featureInput, setFeatures, setFeatureInput)}
//                   className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
//                   disabled={!featureInput.trim()}
//                 >
//                   <Plus size={16} />
//                 </button>
//               </div>
//               {planFeatureMessage && (
//                 <div className="mt-3 p-3 rounded-md bg-amber-50 border border-amber-200 text-amber-700 text-sm">
//                   {planFeatureMessage}
//                 </div>
//               )}
//               <div className="flex flex-wrap gap-2 mt-3">
//                 {features &&
//                   features.split(".").map((f, i) => (
//                     <Chip key={i} label={f} onRemove={() => removeItem(i, features, setFeatures)} />
//                   ))}
//               </div>
//             </div>

//             {/* COVERAGE */}
//             <div>
//               <label className="text-sm font-medium">Coverage</label>
//               <div className="relative mt-1">
//                 <input
//                   value={coverageInput}
//                   onChange={(e) => setCoverageInput(e.target.value)}
//                   placeholder="Type coverage and press +"
//                   className="w-full border px-3 py-2 pr-10 rounded"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => addItem(coverageInput, setCoverage, setCoverageInput)}
//                   className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
//                   disabled={!coverageInput.trim()}
//                 >
//                   <Plus size={16} />
//                 </button>
//               </div>
//               <div className="flex flex-wrap gap-2 mt-3">
//                 {coverage &&
//                   coverage.split(".").map((c, i) => (
//                     <Chip key={i} label={c} onRemove={() => removeItem(i, coverage, setCoverage)} />
//                   ))}
//               </div>
//             </div>

//             {/* EXCLUSIONS */}
//             <div>
//               <label className="text-sm font-medium">Exclusions</label>
//               <div className="relative mt-1">
//                 <input
//                   value={exclusionInput}
//                   onChange={(e) => setExclusionInput(e.target.value)}
//                   placeholder="Type exclusion and press +"
//                   className="w-full border px-3 py-2 pr-10 rounded"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => addItem(exclusionInput, setexclusions, setExclusionInput)}
//                   disabled={!exclusionInput.trim()}
//                   className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
//                 >
//                   <Plus size={16} />
//                 </button>
//               </div>
//               <div className="flex flex-wrap gap-2 mt-3">
//                 {exclusions &&
//                   exclusions.split(".").map((e, i) => (
//                     <Chip key={i} label={e} onRemove={() => removeItem(i, exclusions, setexclusions)} />
//                   ))}
//               </div>
//             </div>

//             {labelType === "subscription" && (
//               <div>
//                 <label className="text-sm font-medium">Retailer Benefits</label>
//                 <div className="relative mt-1">
//                   <input
//                     value={benefitsinput}
//                     onChange={(e) => setBenefitsInput(e.target.value)}
//                     placeholder="Type benefit and press +"
//                     className="w-full border px-3 py-2 pr-10 rounded"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => addItem(benefitsinput, setbenefits, setBenefitsInput)}
//                     disabled={!benefitsinput.trim()}
//                     className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
//                   >
//                     <Plus size={16} />
//                   </button>
//                 </div>

//                 <div className="flex flex-wrap gap-2 mt-3">
//                   {benefits &&
//                     benefits.split(".").map((b, i) => (
//                       <Chip key={i} label={b} onRemove={() => removeItem(i, benefits, setbenefits)} />
//                     ))}
//                 </div>
//               </div>
//             )}

//           </div>

//           {/* ── SUBMIT ── */}
//           <div className="flex justify-end pt-2">
//             <button
//               type="submit"
//               className="w-[200px] bg-blue-600 text-white py-2 rounded"
//               disabled={loading}
//             >
//               {loading ? "Saving..." : initialData ? "Update Product" : "Add Product"}
//             </button>
//           </div>

//         </form>
//       </div>
//     </div>
//   );
// }

// const Chip = ({ label, onRemove }) => (
//   <div className="flex items-center gap-2 bg-slate-100 border rounded-full px-3 py-1 text-sm">
//     <span>{label}</span>
//     <button type="button" onClick={onRemove} className="text-slate-500 hover:text-red-500">
//       ✕
//     </button>
//   </div>
// );

